// GlobalUtils.ts

/**
 * Returns YYYY-MM-DD format strictly required by HTML <input type="date">
 */
export const formatDateToInput = (dateString?: string | null): string => {
  if (!dateString) return '';

  const cleanStr = String(dateString).trim();
  if (!cleanStr) return '';

  // Extract YYYY-MM-DD if ISO format or string with dashes
  let rawDate = cleanStr;
  if (cleanStr.includes('T')) {
    rawDate = cleanStr.split('T')[0];
  } else if (cleanStr.includes(' ')) {
    rawDate = cleanStr.split(' ')[0];
  }

  // Handle DD-MM-YYYY if passed in
  const ddmmyyyyMatch = rawDate.match(/^(\d{2})-(\d{2})-(\d{4})$/);
  if (ddmmyyyyMatch) {
    const [, day, month, year] = ddmmyyyyMatch;
    return `${year}-${month}-${day}`;
  }

  const date = new Date(rawDate);
  if (isNaN(date.getTime())) return '';

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

/**
 * Formats date into DD/MM/YYYY format for visual text display
 */
export const formatDateToDDMMYYYY = (dateString?: string | null): string => {
  const yyyyMmDd = formatDateToInput(dateString);
  if (!yyyyMmDd) return '';

  const [year, month, day] = yyyyMmDd.split('-');
  return `${day}/${month}/${year}`;
};

export const formatDateToMyanmar = (dateString?: string | null): string => {
  const yyyyMmDd = formatDateToInput(dateString);
  if (!yyyyMmDd) return '';

  const [year, month, day] = yyyyMmDd.split('-');
  const monthNames = [
    'ဇန်နဝါရီ',
    'ဖေဖော်ဝါရီ',
    'မတ်',
    'ဧပြီ',
    'မေ',
    'ဇွန်',
    'ဇူလိုင်',
    'ဩဂုတ်',
    'စက်တင်ဘာ',
    'အောက်တိုဘာ',
    'နိုဝင်ဘာ',
    'ဒီဇင်ဘာ',
  ];
  const toMyanmarDigits = (value: string) =>
    value.replace(/\d/g, (digit) => '၀၁၂၃၄၅၆၇၈၉'[Number(digit)]);

  return `${toMyanmarDigits(day)}-${monthNames[Number(month) - 1]}-${toMyanmarDigits(year)}`;
};

/**
 * Formats date into a clean display format (e.g., "10/07/2026")
 */
export const formatDateDisplay = (dateString?: string | null): string => {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString;

  return date.toLocaleDateString('en-GB'); // Outputs: DD/MM/YYYY
};